module.exports = {"key":"sfm","name":"Security First Managers","websiteUrl":"https://www.securityfirstmanagers.com","contactUsLink":"https://www.securityfirstmanagers.com/contact-us/","privacyPolicyLink":"https://www.securityfirstmanagers.com/privacy-policy-2/","termsOfUseLink":"https://www.securityfirstmanagers.com/terms-of-use/","phone":"8773339992","hours":"MON-FRI,8:00 AM-8:00 PM","email":""}


//////////////////
// WEBPACK FOOTER
// ./data/insurance_types/sfm.json
// module id = GpRI
// module chunks = 1